import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './layouts/layout.component';

// Auth
import { AuthGuard } from './core/guards/auth.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./account/account.module').then(m => m.AccountModule)
  },
  {
    // Acompanhamento do cliente: pública, fora do layout e sem guarda.
    // TEM de ficar antes da rota '' — um path vazio sem pathMatch:'full' casa
    // como prefixo de tudo e apanhava esta antes de ela ser avaliada.
    path: 'process-share/:token',
    loadChildren: () => import('./process-share/process-share.module').then(m => m.ProcessShareModule)
  },
  {
    // CMI partilhado com o proprietário: mesma regra da rota acima — pública,
    // fora do layout e antes do path vazio.
    path: 'cmi-share/:token',
    loadChildren: () => import('./cmi-share/cmi-share.module').then(m => m.CmiShareModule)
  },
  {
    // Portal do proprietário (substitui o cmi-share nos links novos): pública,
    // fora do layout e antes do path vazio.
    path: 'owner-portal/:token',
    loadChildren: () => import('./owner-portal/owner-portal.module').then(m => m.OwnerPortalModule)
  },
  {
    // Ficha de visita virtual (chat v3): pública, fora do layout e antes do
    // path vazio, como as rotas por token acima.
    path: 'ficha-visita/:token',
    loadChildren: () => import('./visit-form-public/visit-form-public.module').then(m => m.VisitFormPublicModule)
  },
  {
    path: '', component: LayoutComponent,
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), /*canActivate: [AuthGuard], canLoad: [AuthGuard]*/
  },
  {
    path: 'error',
    loadChildren: () => import('./errors/errors.module').then(m => m.ErrorsModule), canActivate: [AuthGuard], canLoad: [AuthGuard]
  },
  { path: '**', redirectTo: 'error/404-cover', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
